export const fmtNumber = (v) => {
  if (v === null || v === undefined) return '-';
  const n = Number(v);
  if (!Number.isFinite(n)) return String(v);
  return n.toLocaleString('ko-KR', {
    useGrouping: true,
    minimumFractionDigits: 0,
    maximumFractionDigits: 10,
  });
};

export const fmtValue = (v) => {
  if (v === null || v === undefined) return '-';

  // Date 객체
  if (v instanceof Date) {
    return v.toLocaleDateString('ko-KR');
  }

  // 숫자 타입
  if (typeof v === 'number') {
    if (!Number.isFinite(v)) return '-';
    return v.toLocaleString('ko-KR', {
      useGrouping: true,
      minimumFractionDigits: 0,
      maximumFractionDigits: 10,
    });
  }

  const s = String(v).trim();
  if (s === '') return '-';

  const numLike = s.replace(/,/g, '');
  if (/^-?\d+(\.\d+)?$/.test(numLike)) {
    const n = Number(numLike);
    if (Number.isFinite(n)) {
      return n.toLocaleString('ko-KR', {
        useGrouping: true,
        minimumFractionDigits: 0,
        maximumFractionDigits: 10,
      });
    }
  }

  return s;
};